import each from 'lodash/each'

import Animation from '../classes/Animation'

// import { CSS } from 'utils/easings'
import { calculate, split } from '../utils/text'

export default class extends Animation {
  constructor ({ element }) {
    const lines = []
    const paragraphs = element.querySelectorAll('h1, h2, p')

    if (paragraphs.length !== 0) {
      each(paragraphs, element => {
        split({ element })
        split({ element })

        lines.push(...element.querySelectorAll('span span'))
      })
    } else {
      split({ element })
      split({ element })

      lines.push(...element.querySelectorAll('span span'))
    }

    super({
      element,
      elements: {
        lines
      }
    })

    this.reset = false

    this.onResize()

    if ('IntersectionObserver' in window) {
      this.animateOut()
    }

  }

  animateIn () {
    super.animateIn()

    this.elements.lines.forEach((line, lineIndex) => {
      line.style.transition = `transform 1.2s ${(lineIndex - 1) * 0.033}s cubic-bezier(0.77, 0, 0.175, 1)`
      line.style[this.transformPrefix] = 'translateY(0)'
      // line.forEach(word => {
      //   word.style.transition = `transform 1.5s ${lineIndex * 0.1}s cubic-bezier(0.77, 0, 0.175, 1)`
      //   word.style[this.transformPrefix] = 'translateY(0)'
      // })
    })
  }

  animateOut () {
    super.animateOut()

    // each(this.lines, line => {
    //   each(line, word => {
    //     word.style[this.transformPrefix] = 'translateY(100%)'
    //   })
    // })

    console.log('animateOut this.elements.lines', this.elements.lines)

    this.elements.lines.slice().reverse().forEach((line, lineIndex) => {
      line.style.transition = `transform .9s ${(lineIndex - 1) * 0.02475}s cubic-bezier(0.77, 0, 0.175, 1)`
      line.style[this.transformPrefix] = 'translateY(100%)'
      // line.forEach(word => {
      //   console.log('word', word)
      //   word.style[this.transformPrefix] = 'translateY(100%)'
      // })
    })
  }

  onResize () {
    // this.lines = calculate(this.elements.lines)
  }
}
